import { List, Record } from 'immutable';
import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';
import ReservationRequest from '../records/ReservationRequest';
import { resolve } from '../helpers/LinkMapper';


const State = new Record({
    reservationRequest: new ReservationRequest(),
    outwardService: null,
    outwardFare: null,
    inwardService: null,
    inwardFare: null,
});

const defaultState = new State();

export class ReservationRequestStore extends BaseStore {
    deserialize(serialized) {
        if (serialized) {
            return defaultState.merge({
                reservationRequest: resolve(serialized.reservationRequest).as(ReservationRequest),
            });
        }

        return defaultState;
    }

    getState() {
        return this.state;
    }

    getAvailabilityParams () {
        return {
            ...this.state.get('selectedFare'),
            ...this.state.get('selectedJourneys'),
            ...this.state.get('bikesCount'),
            ...this.state.get('passengersCount'),
        };
    }

    getInwardFare() {
        return this.state.get('inwardFare');
    }

    getOutwardFare() {
        return this.state.get('outwardFare');
    }

    handleClear() {
        this.setState(defaultState);
    }

    getReservationRequest() {
        return this.state.get('reservationRequest');
    }

    setPassengers({ passengers }) {
        this.setState(
            this.state.set(
                'reservationRequest',
                this.state.get('reservationRequest').set('passengers', new List(passengers))
            )
        );
    }

    setBikes({ bikesQty }) {
        this.setState(
            this.state.set('reservationRequest',
                this.state.get('reservationRequest').set('bikes', bikesQty)
            )
        );
    }

    setRequestSeats({ requestSeats }) {
        this.setState(
            this.state.set('reservationRequest',
                this.state.get('reservationRequest').set('requestSeats', requestSeats)
            )
        );
    }

    setOutwardService({ journey }) {
        this.setState(this.state.set('outwardService', journey ));
        this.emitChange();
    }

    resetOutwardService() {
        this.setState(this.state.set('outwardService', null ));
        this.emitChange();
    }

    setInwardService({ journey }) {
        this.setState(this.state.set('inwardService', journey ));
        this.emitChange();
    }

    resetInwardService() {
        this.setState(this.state.set('inwardService', null ));
        this.emitChange();
    }

    setOutwardFare({ fare }) {
        this.setState(this.state.set('outwardFare', fare));
        this.emitChange();
    }

    resetOutwardFare() {
        this.setState(this.state.set('outwardFare', null));
        this.emitChange();
    }

    setInwardFare({ fare }) {
        this.setState(this.state.set('inwardFare', fare));
        this.emitChange();
    }

    resetInwardFare() {
        this.setState(this.state.set('inwardFare', null));
        this.emitChange();
    }

    getActionHandlers() {
        return {
            [ActionTypes.SET_RESERVATION_REQUEST_PASSENGERS]: this.setPassengers,
            [ActionTypes.SET_RESERVATION_REQUEST_BIKES]: this.setBikes,
            [ActionTypes.CLEAR_RESERVATION_REQUEST_STORE]: this.handleClear,
            [ActionTypes.CREATE_RESERVATION_FAILED]: this.handleClear,
            [ActionTypes.SET_RESERVATION_REQUEST_OUTBOUND_SERVICE]: this.setOutwardService,
            [ActionTypes.SET_RESERVATION_REQUEST_INBOUND_SERVICE]: this.setInwardService,
            [ActionTypes.SET_RESERVATION_REQUEST_OUTBOUND_FARE]: this.setOutwardFare,
            [ActionTypes.SET_RESERVATION_REQUEST_INBOUND_FARE]: this.setInwardFare,
            [ActionTypes.RESET_RESERVATION_REQUEST_OUTBOUND_SERVICE]: this.resetOutwardService,
            [ActionTypes.RESET_RESERVATION_REQUEST_INBOUND_SERVICE]: this.resetInwardService,
            [ActionTypes.RESET_RESERVATION_REQUEST_OUTBOUND_FARE]: this.resetOutwardFare,
            [ActionTypes.RESET_RESERVATION_REQUEST_INBOUND_FARE]: this.resetInwardFare,
            [ActionTypes.SET_RESERVATION_REQUEST_SEATS]: this.setRequestSeats,
        };
    }
}

const instance = new ReservationRequestStore({ storageKey: 'reservation-request' });

export default instance;



// WEBPACK FOOTER //
// ./src/stores/ReservationRequestStore.js